import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import SimulatorFormFonts from './SimulatorFormFont'
import SimulatorFormStyle from './SimulatorFormStyle'
import type { SimulatorFormBrandType, SimulatorBrandForms } from './simulatorTypes'

const FORM_MAP: SimulatorBrandForms = {
  [BrandFormEnum.STYLE]: SimulatorFormStyle,
  ...(SimulatorFormFonts as SimulatorBrandForms),
}

const SimulatorFormBrand: SimulatorFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(SimulatorFormBrand) as typeof SimulatorFormBrand
